export default __webpack_public_path__ + "js/components/liveClassPurchasePage/component/BenefitScreen/close-dweb-f98fd27bc79324f384e63b284ff34f35.svg";